import { styled } from 'linaria/react';

export const StyledOtherUsersText = styled.span`
  font-weight: 600;
  cursor: pointer;
`;
